import RequestBuilder from '../Lib/Requests';

export default class GtemplateReminderService {
  api = new RequestBuilder();

  buildCreateGtemplateReminderRequest(data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: '/v2/reminder',
      method: 'post',
      service: 'maintenance',
    };
  }
  async createGtemplateReminder(body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildCreateGtemplateReminderRequest(body, cancelToken)
    );
    return data;
  }

  buildGetPaginatedGtemplateRemindersRequest(params, cancelToken) {
    return {
      cancelToken,
      endpoint: '/v2/reminder',
      method: 'get',
      params,
      service: 'maintenance',
    };
  }
  async getPaginatedGtemplateReminders(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildGetPaginatedGtemplateRemindersRequest(params, cancelToken)
    );
    return data;
  }

  buildGetGtemplateReminderRequest(reminderId, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v2/reminder/${reminderId}`,
      method: 'get',
      service: 'maintenance',
    };
  }
  async getGtemplateReminder(reminderId, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildGetGtemplateReminderRequest(reminderId, cancelToken)
    );
    return data;
  }

  buildUpdateGtemplateReminderRequest(reminderId, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/v2/reminder/${reminderId}`,
      method: 'put',
      service: 'maintenance',
    };
  }
  async updateGtemplateReminder(reminderId, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildUpdateGtemplateReminderRequest(reminderId, body, cancelToken)
    );
    return data;
  }

  buildDeleteGtemplateReminderRequest(reminderId, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v2/reminder/${reminderId}`,
      method: 'delete',
      service: 'maintenance',
    };
  }
  async deleteGtemplateReminder(reminderId, cancelToken) {
    return this.api.request(
      this.buildDeleteGtemplateReminderRequest(reminderId, cancelToken)
    );
  }
}
